import { render, staticRenderFns } from "./BookingPassengers.vue?vue&type=template&id=0bd65a10&"
import script from "./BookingPassengers.vue?vue&type=script&lang=js&"
export * from "./BookingPassengers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports